export default {
      id: "icon-spikeable-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite.svg#icon-spikeable",
      toString: function () {
        return this.url;
      }
    }